import { render, staticRenderFns } from "./RemoveAccount.vue?vue&type=template&id=6fc6fe53&scoped=true"
import script from "./RemoveAccount.vue?vue&type=script&lang=js"
export * from "./RemoveAccount.vue?vue&type=script&lang=js"
import style0 from "./RemoveAccount.vue?vue&type=style&index=0&id=6fc6fe53&prod&lang=scss&scoped=true"
import style1 from "./RemoveAccount.vue?vue&type=style&index=1&id=6fc6fe53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6fe53",
  null
  
)

export default component.exports